/**
 * API service module for the inventor form
 */
class InventorFormAPI {
    constructor() {
        this.baseUrl = gadgetAppUrl;
    }

    /**
     * Submits the inventor registration form
     * @param {Object} formData - The form data to submit
     * @returns {Promise<Object>} The API response
     */
    async submitInventorRegistration(formData) {
        try {
            const requestBody = {
                inventorDetails: JSON.stringify(formData)
            };

            const response = await fetch(`${this.baseUrl}/inventorRegister`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error submitting inventor registration:', error);
            throw error;
        }
    }

    /**
     * Uploads a file to Azure storage
     * @param {FormData} formData - The form data containing the file
     * @returns {Promise<Object>} The API response
     */
    async uploadFile(formData) {
        try {
            const response = await fetch(`${this.baseUrl}/azureUpload`, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                throw new Error(`File upload failed: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error uploading file:', error);
            throw error;
        }
    }
}

// Export for use in other modules
window.InventorFormAPI = InventorFormAPI;
